export default "__VITE_ASSET__24ad0e21__"